import { render, staticRenderFns } from "./ModalNovoItem.vue?vue&type=template&id=2779569e&scoped=true"
import script from "./ModalNovoItem.vue?vue&type=script&lang=js"
export * from "./ModalNovoItem.vue?vue&type=script&lang=js"
import style0 from "./ModalNovoItem.vue?vue&type=style&index=0&id=2779569e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2779569e",
  null
  
)

export default component.exports